// import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import { loginStart, loginSuccess, loginFailure } from "../../store/authSlice";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Link,
//   Paper,
//   CircularProgress,
// } from "@mui/material";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import axios from "axios";
// import { API_BASE_URL } from "../../config";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import { Login } from "./login";
// import { OtpPage } from "./otpPage";
// import { ForgotPassword } from "./forgotPass";
// import { ResetPassword } from "./resetPass";
// import { AuthInfoBox } from "../../Components/authSide/authSideComponent";
// import { CaptchaComponent } from "../../Components/captcha/captchaComponent";

// const passwordRules = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

// const validationSchema = Yup.object({
//   name: Yup.string().required("Name is required"),
//   email: Yup.string().email("Invalid email address").required("Email is required"),
//   mobile_number: Yup.string()
//     .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
//     .required("Mobile number is required"),
//   password: Yup.string()
//     .matches(
//       passwordRules,
//       "Password must be at least 8 characters, include one uppercase letter and one special character"
//     )
//     .required("Password is required"),
//   confirmPassword: Yup.string()
//     .oneOf([Yup.ref("password"), null], "Passwords must match")
//     .required("Confirm Password is required"),
//   captcha_value: Yup.string().required("Captcha is required"),
// });

// export const RegistrationPage = () => {
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     severity: "success",
//     message: "",
//   });
//   const [otpPage, setOtpPage] = useState(false);
//   const [showLogin, setShowLogin] = useState(false);
//   const [registeredEmail, setRegisteredEmail] = useState("");
//   const [registeredMobile, setRegisteredMobile] = useState("");
//   const [showForgot, setShowForgot] = useState(false);
//   const [showReset, setShowReset] = useState(false);
//   const [resetEmail, setResetEmail] = useState("");
//   const [captchaKey, setCaptchaKey] = useState("");

//   const handleOtpVerified = () => {
//     setShowLogin(true);
//     setOtpPage(false);
//   };

//   const handleShowLogin = (event) => {
//     if (event) event.preventDefault();
//     setShowLogin(true);
//     setOtpPage(false);
//     setShowForgot(false);
//     setShowReset(false);
//   };

//   const handleShowRegister = () => {
//     setShowLogin(false);
//     setOtpPage(false);
//     setShowForgot(false);
//     setShowReset(false);
//   };

//   const formik = useFormik({
//     initialValues: {
//       name: "",
//       email: "",
//       password: "",
//       confirmPassword: "",
//       mobile_number: "",
//       captcha_value: "",
//     },
//     validationSchema,
//     onSubmit: async (values) => {
//       dispatch(loginStart());
//       setLoading(true);
//       try {
//         const { data } = await axios.post(
//           `${API_BASE_URL}/auth/signup/`,
//           {
//             name: values.name,
//             email: values.email,
//             password: values.password,
//             phone_number: values.mobile_number,
//             captcha_key: captchaKey,
//             captcha_value: values.captcha_value,
//           },
//           { headers: { "Content-Type": "application/json" } }
//         );

//         if (data.access_token && data.refresh_token) {
//           dispatch(
//             loginSuccess({
//               access_token: data.access_token,
//               refresh_token: data.refresh_token,
//               user: data.user,
//               role: data.role,
//             })
//           );
//         }

//         setSnackbar({
//           open: true,
//           severity: "success",
//           message: "Registered successfully!",
//         });
//         setRegisteredEmail(values.email);
//         setRegisteredMobile(values.mobile_number);
//         setOtpPage(true);
//       } catch (error) {
//         // Handle error message string or object safely
//         let errMsg = "Registration failed!";
//         if (error.response?.data) {
//           if (typeof error.response.data === "string") {
//             errMsg = error.response.data;
//           } else if (typeof error.response.data.error === "string") {
//             errMsg = error.response.data.error;
//           } else {
//             errMsg = JSON.stringify(error.response.data);
//           }
//         }
//         dispatch(loginFailure(errMsg));
//         setSnackbar({
//           open: true,
//           severity: "error",
//           message: errMsg,
//         });
//       } finally {
//         setLoading(false);
//       }
//     },
//   });

//   return (
//     <Box sx={{ height: "100vh", display: "flex", flexDirection: "row" }}>
//       {/* Left side info */}
//       <AuthInfoBox />

//       {/* Form side */}
//       <Box
//         sx={{
//           maxWidth: { xs: "100%", md: "40%" },
//           minWidth: { xs: "100%", md: "40%" },
//           mt:3,
//           mb:2,
//           height: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <Paper
//           elevation={3}
//           sx={{ p: 4, width: "100%", maxWidth: 350, maxHeight: "80vh", overflowY: "auto" }}
//         >
//           {showLogin ? (
//             <Login
//               handleShowRegister={handleShowRegister}
//               handleShowForgot={() => {
//                 setShowForgot(true);
//                 setShowLogin(false);
//                 setShowReset(false);
//               }}
//             />
//           ) : otpPage ? (
//             <OtpPage
//               email={registeredEmail}
//               mobile_number={registeredMobile}
//               onOtpVerified={handleOtpVerified}
//             />
//           ) : showForgot ? (
//             <ForgotPassword
//               onReset={(email) => {
//                 setResetEmail(email);
//                 setShowForgot(false);
//                 setShowReset(true);
//               }}
//               onBackToLogin={handleShowLogin}
//             />
//           ) : showReset ? (
//             <ResetPassword email={resetEmail} onBackToLogin={handleShowLogin} />
//           ) : (
//             <>
//               <Typography variant="h5" fontWeight="bold" gutterBottom textAlign="center">
//                 Getting started
//               </Typography>
//               <Box
//                 component="form"
//                 onSubmit={formik.handleSubmit}
//                 sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//               >
//                 <TextField
//                   label="Name"
//                   name="name"
//                   size="small"
//                   value={formik.values.name}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.name && Boolean(formik.errors.name)}
//                   helperText={formik.touched.name && formik.errors.name}
//                   fullWidth
//                   required
//                 />
//                 <TextField
//                   label="Email"
//                   name="email"
//                   type="email"
//                   size="small"
//                   value={formik.values.email}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.email && Boolean(formik.errors.email)}
//                   helperText={formik.touched.email && formik.errors.email}
//                   fullWidth
//                   required
//                 />
//                 <TextField
//                   label="Mobile Number"
//                   name="mobile_number"
//                   value={formik.values.mobile_number}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.mobile_number && Boolean(formik.errors.mobile_number)}
//                   helperText={formik.touched.mobile_number && formik.errors.mobile_number}
//                   fullWidth
//                   required
//                   size="small"
//                 />
//                 <TextField
//                   label="Password"
//                   name="password"
//                   type="password"
//                   value={formik.values.password}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.password && Boolean(formik.errors.password)}
//                   helperText={formik.touched.password && formik.errors.password}
//                   fullWidth
//                   size="small"
//                   required
//                 />
//                 <TextField
//                   label="Confirm Password"
//                   name="confirmPassword"
//                   type="password"
//                   value={formik.values.confirmPassword}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
//                   helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
//                   fullWidth
//                   size="small"
//                   required
//                 />

//                 {/* Captcha component */}
//                 <CaptchaComponent onChange={formik.handleChange} setCaptchaKey={setCaptchaKey} />
//                 <TextField
//                   label="Captcha"
//                   name="captcha_value"
//                   size="small"
//                   value={formik.values.captcha_value}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.captcha_value && Boolean(formik.errors.captcha_value)}
//                   helperText={formik.touched.captcha_value && formik.errors.captcha_value}
//                   fullWidth
//                   required
//                 />

//                 <Button
//                   type="submit"
//                   variant="contained"
//                   color="primary"
//                   fullWidth
//                   disabled={loading}
//                   startIcon={loading ? <CircularProgress size={20} /> : null}
//                 >
//                   {loading ? "Registering..." : "Register"}
//                 </Button>
//               </Box>
//               <Typography variant="body2" align="center" sx={{ mt: 2 }}>
//                 Already have an account?{" "}
//                 <Link onClick={handleShowLogin} underline="hover" sx={{ cursor: "pointer" }}>
//                   Login
//                 </Link>
//               </Typography>
//             </>
//           )}
//         </Paper>
//       </Box>

//       {/* Custom Snackbar */}
//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       />
//     </Box>
//   );
// };


import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { loginStart, loginSuccess, loginFailure } from "../../store/authSlice";
import {
  Box,
  TextField,
  Button,
  Typography,
  Link,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import { Login } from "./login";
import { OtpPage } from "./otpPage";
import { ForgotPassword } from "./forgotPass";
import { ResetPassword } from "./resetPass";
import { AuthInfoBox } from "../../Components/authSide/authSideComponent";
import { CaptchaComponent } from "../../Components/captcha/captchaComponent";
import { useTranslation } from "react-i18next";

// Password rule: min 8 chars, one uppercase, one special char
const passwordRules = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

const validationSchema = (t) =>
  Yup.object({
    name: Yup.string().required(t("registration.errors.nameRequired")),
    email: Yup.string()
      .email(t("registration.errors.invalidEmail"))
      .required(t("registration.errors.emailRequired")),
    mobile_number: Yup.string()
      .matches(/^[0-9]{10}$/, t("registration.errors.invalidMobile"))
      .required(t("registration.errors.mobileRequired")),
    password: Yup.string()
      .matches(
        passwordRules,
        t("registration.errors.passwordRules")
      )
      .required(t("registration.errors.passwordRequired")),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], t("registration.errors.mismatch"))
      .required(t("registration.errors.confirmPasswordRequired")),
    captcha_value: Yup.string().required(t("registration.errors.captchaRequired")),
  });

export const RegistrationPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const [otpPage, setOtpPage] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [registeredMobile, setRegisteredMobile] = useState("");
  const [showForgot, setShowForgot] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [captchaKey, setCaptchaKey] = useState("");

  const handleOtpVerified = () => {
    setShowLogin(true);
    setOtpPage(false);
  };

  const handleShowLogin = (event) => {
    if (event) event.preventDefault();
    setShowLogin(true);
    setOtpPage(false);
    setShowForgot(false);
    setShowReset(false);
  };

  const handleShowRegister = () => {
    setShowLogin(false);
    setOtpPage(false);
    setShowForgot(false);
    setShowReset(false);
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      mobile_number: "",
      captcha_value: "",
    },
    validationSchema: validationSchema(t),
    onSubmit: async (values) => {
      dispatch(loginStart());
      setLoading(true);
      try {
        const { data } = await axios.post(
          `${API_BASE_URL}/auth/signup/`,
          {
            name: values.name,
            email: values.email,
            password: values.password,
            phone_number: values.mobile_number,
            captcha_key: captchaKey,
            captcha_value: values.captcha_value,
          },
          { headers: { "Content-Type": "application/json" } }
        );

        if (data.access_token && data.refresh_token) {
          dispatch(
            loginSuccess({
              access_token: data.access_token,
              refresh_token: data.refresh_token,
              user: data.user,
              role: data.role,
            })
          );
        }

        setSnackbar({
          open: true,
          severity: "success",
          message: t("registration.success"),
        });
        setRegisteredEmail(values.email);
        setRegisteredMobile(values.mobile_number);
        setOtpPage(true);
      } catch (error) {
        let errMsg = t("registration.failure");
        if (error.response?.data) {
          if (typeof error.response.data === "string") {
            errMsg = error.response.data;
          } else if (typeof error.response.data.error === "string") {
            errMsg = error.response.data.error;
          } else {
            errMsg = JSON.stringify(error.response.data);
          }
        }
        dispatch(loginFailure(errMsg));
        setSnackbar({
          open: true,
          severity: "error",
          message: errMsg,
        });
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "row" }}>
      {/* Left side info */}
      <AuthInfoBox />

      {/* Form side */}
      <Box
        sx={{
          maxWidth: { xs: "100%", md: "40%" },
          minWidth: { xs: "100%", md: "40%" },
          mt: 3,
          mb: 2,
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: "100%",
            maxWidth: 350,
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          {showLogin ? (
            <Login
              handleShowRegister={handleShowRegister}
              handleShowForgot={() => {
                setShowForgot(true);
                setShowLogin(false);
                setShowReset(false);
              }}
            />
          ) : otpPage ? (
            <OtpPage
              email={registeredEmail}
              mobile_number={registeredMobile}
              onOtpVerified={handleOtpVerified}
            />
          ) : showForgot ? (
            <ForgotPassword
              onReset={(email) => {
                setResetEmail(email);
                setShowForgot(false);
                setShowReset(true);
              }}
              onBackToLogin={handleShowLogin}
            />
          ) : showReset ? (
            <ResetPassword email={resetEmail} onBackToLogin={handleShowLogin} />
          ) : (
            <>
              <Typography
                variant="h5"
                fontWeight="bold"
                gutterBottom
                textAlign="center"
              >
                {t("registration.gettingStarted")}
              </Typography>
              <Box
                component="form"
                onSubmit={formik.handleSubmit}
                sx={{ display: "flex", flexDirection: "column", gap: 2 }}
              >
                <TextField
                  label={t("registration.fields.name")}
                  name="name"
                  size="small"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                  fullWidth
                  required
                />
                <TextField
                  label={t("registration.fields.email")}
                  name="email"
                  type="email"
                  size="small"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  fullWidth
                  required
                />
                <TextField
                  label={t("registration.fields.mobile")}
                  name="mobile_number"
                  value={formik.values.mobile_number}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.mobile_number && Boolean(formik.errors.mobile_number)}
                  helperText={formik.touched.mobile_number && formik.errors.mobile_number}
                  fullWidth
                  required
                  size="small"
                />
                <TextField
                  label={t("registration.fields.password")}
                  name="password"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.password && Boolean(formik.errors.password)}
                  helperText={formik.touched.password && formik.errors.password}
                  fullWidth
                  size="small"
                  required
                />
                <TextField
                  label={t("registration.fields.confirmPassword")}
                  name="confirmPassword"
                  type="password"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                  helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                  fullWidth
                  size="small"
                  required
                />

                {/* Captcha component */}
                <CaptchaComponent onChange={formik.handleChange} setCaptchaKey={setCaptchaKey} />
                <TextField
                  label={t("registration.fields.captcha")}
                  name="captcha_value"
                  size="small"
                  value={formik.values.captcha_value}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.captcha_value && Boolean(formik.errors.captcha_value)}
                  helperText={formik.touched.captcha_value && formik.errors.captcha_value}
                  fullWidth
                  required
                />

                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={20} /> : null}
                >
                  {loading ? t("registration.buttons.registering") : t("registration.buttons.register")}
                </Button>
              </Box>
              <Typography variant="body2" align="center" sx={{ mt: 2 }}>
                {t("registration.alreadyHaveAccount")}{" "}
                <Link onClick={handleShowLogin} underline="hover" sx={{ cursor: "pointer" }}>
                  {t("registration.loginLink")}
                </Link>
              </Typography>
            </>
          )}
        </Paper>
      </Box>

      {/* Custom Snackbar */}
      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      />
    </Box>
  );
};
